<template lang="pug">
v-row
  v-col(
    :cols="12"
    :sm="6"
    :md="4"
  )
    .grid__item(:class="{ dragging: isDragging }")
      upload-file(
        @dragging="holdDragging"
        @drop-files.prevent="dropFiles"
      )
        .card.d-flex.pa-5.flex-column.align-center.justify-center.fill-height
          v-icon(x-large).mb-4 mdi-cloud-upload-outline
          p.caption.mb-2 Максимальный размер файла не более 5мб
          p.text-center.mb-2 Перенесите сюда изображения
          input.mb-4(
            type="file"
            style="display: none"
            ref="image"
            multiple
            accept="image/*"
            @change="onFilesPicked"
          )
          v-btn.mb-4(
            @click="pickFile"
            color="primary"
            small
          ) Выбрать изображения
  template(v-for="(image, index) in uploadedImages")
    v-col(
      :key="image.name"
      :cols="12"
      :sm="6"
      :md="4"
    )
      .grid__item
        .grid__image.relative
          img(:src="image.url")
          v-btn.top-right-10(
            color="error"
            x-small
            fab
            @click="deleteImage(index, image.id)"
          )
            v-icon mdi-trash-can-outline
        v-textarea.rounded-0.mt-2(
          v-if="!image.id"
          v-model="uploadedImages[index].description"
          placeholder="Описание картинки"
          outlined
          dense
          no-resize
          :rows="2"
          :counter="$options.constants.INPUT_LENGTH.textField"
        )
</template>

<script>
import UploadFile from '@/components/UploadFile.vue';
import uploadService from '@/services/API/upload';
import { INPUT_LENGTH } from '@/constants/inputLength';

export default {
  constants: {
    INPUT_LENGTH,
  },
  components: {
    UploadFile,
  },
  props: {
    initImages: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isDragging: false,
      uploadedImages: [],
      images: [],
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.selectedImage = null;
      }
    },
    uploadedImages: {
      deep: true,
      handler(val) {
        this.$emit('change', val);
      },
    },
  },
  created() {
    this.uploadedImages = this.initImages;
  },
  methods: {
    dropFiles(e) {
      e.target.files = e.dataTransfer.files;
      this.onFilesPicked(e);
    },
    holdDragging(isDragging) {
      this.isDragging = isDragging;
    },
    pickFile() {
      this.$refs.image.click();
    },

    async onFilesPicked(e) {
      const { files } = e.target;
      [...files].forEach(async (file) => {
        await this.uploadImage(file);
      });
    },

    async uploadImage(file) {
      await this.$rHandler(uploadService.uploadFile(file), (response) => {
        const newImages = [...this.uploadedImages];
        const newImage = {
          url: response.data.data.url,
          file_name: response.data.data.file_name,
          description: '',
        };
        newImages.push(newImage);
        this.uploadedImages = newImages;
        this.$emit('addImg', newImage);
      });
    },

    deleteImage(index, id) {
      this.uploadedImages.splice(index, 1);
      this.$emit('deleteImg', id);
    },
  },
};
</script>

<style lang="scss">
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 10px;
  width: 100%;
  &__image {
    height: 150px;
  }
  &__item {
    height: 100%;
    max-height: 300px;
    width: auto;
    cursor: pointer;
    position: relative;
    .card {
      border: 2px dashed #ccc;
    }
    img,
    iframe {
      max-height: 220px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.dragging {
  border: none;

  position: relative;
  background-image: linear-gradient(90deg, white 50%, transparent 50%), linear-gradient(90deg, white 50%, transparent 50%),
    linear-gradient(0deg, white 50%, transparent 50%), linear-gradient(0deg, white 50%, transparent 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
  background-position: left top, right bottom, left bottom, right top;
  animation: border-dance 0.3s infinite linear;
}
@keyframes border-dance {
  0% {
    background-position: left top, right bottom, left bottom, right top;
  }
  100% {
    background-position: left 15px top, right 15px bottom, left bottom 15px, right top 15px;
  }
}
.grid img:nth-child(3n-2) {
  grid-row: span 2;
}
.grid img:nth-child(6n-2) {
  grid-row: span 1;
}
</style>
